class CalculateByDays {
  constructor() {
    this.values = {};
    this.catalog = {};
  }

  reset() {
    this.values = {};
  }

  calculate(values, catalog, alwaysCalculate = false) {
    const {
      quantity,
      dateFrom,
      dateTo,
      isCalculatedByDays,
      isAccommodation
    } = values;

    if (
      quantity !== null &&
      quantity > 0 &&
      dateFrom !== null &&
      isCalculatedByDays !== null &&
      Object.keys(catalog).length > 0
    ) {
      if (!alwaysCalculate) {
        const newValues = {
          rateFrom: catalog.rateFrom ? catalog.rateFrom : catalog.RateFrom,
          rateTo: catalog.rateTo ? catalog.rateTo : catalog.RateTo,
          quantity,
          dateFrom,
          dateTo,
          isCalculatedByDays,
          isAccommodation
        };

        if (JSON.stringify(newValues) === JSON.stringify(this.values)) {
          return false;
        }
      }

      this.values = {
        rateFrom: catalog.rateFrom ? catalog.rateFrom : catalog.RateFrom,
        rateTo: catalog.rateTo ? catalog.rateTo : catalog.RateTo,
        quantity,
        dateFrom,
        dateTo,
        isCalculatedByDays,
        isAccommodation
      };

      return this.values;
    }

    return false;
  }
}

export default new CalculateByDays();
